import { createStateContext } from '../../../foundation/react/react-context-state';

export type AuthState = {
  isAuthenticated: boolean;
};

export const AuthStateContext = createStateContext<AuthState>({
  isAuthenticated: false,
});
